// Matches FastActionsRow's `reviewedButtonActive` treatment (a green fill + border), rather
// than an outline drawn on top of the field's existing look.
const AI_HIGHLIGHT_FILL = {
  border: '1px solid',
  borderColor: 'success.main',
  backgroundColor: 'success.light',
};

// For a raw MUI Input component (e.g. BoxField's FilledInput) - `sx` there applies directly to
// that input's own root, so the fill lands exactly on the visible field.
export const AI_HIGHLIGHT_RAW_INPUT_SX = AI_HIGHLIGHT_FILL;

// For a composite MUI TextField (SPayeeField, CategoryField, TagsField) - TextField's own `sx`
// prop only reaches its outer FormControl root (which also wraps the label), not the visible
// input container, so applying AI_HIGHLIGHT_RAW_INPUT_SX there directly fills the whole
// FormControl. This nested-selector-only variant targets just the inner input container instead.
export const AI_HIGHLIGHT_TEXTFIELD_SX = {
  '& .MuiFilledInput-root, & .MuiOutlinedInput-root, & .MuiInputBase-root': AI_HIGHLIGHT_FILL,
};
